import React from 'react';
import {
  InformedTemplate as SdkInformedTemplate,
  InformedTemplateProps,
} from '@display-component/pc';

import 'swiper/css';

const InformedTemplate = (props: InformedTemplateProps) => {
  return <SdkInformedTemplate {...props} />;
};

export default InformedTemplate;
